var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-form-file", {
        attrs: {
          placeholder: "Datei auswählen...",
          "drop-placeholder": "Foto hier reinziehen...",
          "browse-text": "Datei wählen",
          accept: "image/*, application/pdf"
        },
        on: { input: _vm.emitChangeEvent },
        model: {
          value: _vm.file,
          callback: function($$v) {
            _vm.file = $$v
          },
          expression: "file"
        }
      }),
      _vm._v(" "),
      _c("Requirements", { attrs: { requirements: _vm.requirements } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }